export const investorHighlights = [
  { label: "Factory cost / unit (3,000, sea)", value: "$1.28" },
  { label: "First production run", value: "$3,840" },
  { label: "Target retail price", value: "$14.99" },
  { label: "Series designed", value: "3" },
];

export const unitEconomics = [
  { channel: "Direct to consumer", price: 14.99, cost: 1.95 },
  { channel: "Shop wholesale", price: 7.5, cost: 1.95 },
  { channel: "Distributor", price: 5.0, cost: 1.95 },
];

export const costNote = "Cost = $1.28 factory price (shipping to one US address included) plus about $0.67 for a retail box, barcode, and duties. The $0.67 is an estimate.";

export const useOfFunds = [
  { label: "Series 01 production (3,000 units) + samples", pct: 20 },
  { label: "Retail boxes, barcodes & countertop displays", pct: 20 },
  { label: "Shop samples & distributor outreach", pct: 20 },
  { label: "Trade shows", pct: 15 },
  { label: "Brand, content & online store", pct: 15 },
  { label: "Legal, insurance & reserve", pct: 10 },
];

export const roadmap = [
  { when: "Month 0–1", title: "Artwork & sample", text: "Place Series 01 art on the factory template and approve a printed sample." },
  { when: "Month 1–3", title: "Production", text: "3,000 units: 25–30 days to produce, then 26–28 days by sea." },
  { when: "Month 3–5", title: "Launch Series 01", text: "Countertop displays in pilot shops, plus direct online sales." },
  { when: "When it sells", title: "Series 02 & beyond", text: "Series 01 sales fund the next character series, then the Pattern Collection, then printed baggies. Only one line is in production at a time." },
];

export const brandAdvantage = [
  { title: "Existing storefront", text: "Launches on SKLUNX.com, so there's no new site, checkout, or brand to build from scratch." },
  { title: "A built-in audience", text: "It reaches the same customers who already buy No Problemo, Pound Town, and $5 Bumps." },
  { title: "A path to more products", text: "Character series, a Pattern Collection with 36 designs, and printed baggies all sell through the same channels." },
];

export const raise = {
  amount: "$25,000",
  instrument: "SAFE or revenue share",
  minimum: "$1,000",
};
